// Auto-generated per-query builders for PDMProduct
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { PDMProductReadAPI, PDMProductWriteAPI, PDMProductReadAPISchema, PDMProductWriteAPISchema } from '../types/pdmproduct';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, BelongsToIndustry, CurrentTaskAttachedTo, HasActions, HasMembers, HasProduct, HasRequirements, HasRootPart, HasSupplyChainCriteria, IslandHoldsPin, Specializes } from '../../relationships/relationship';

import { PDMAction } from './pdmaction';
import { PDMRequirement } from './pdmrequirement';
import { PDMSupplyChainCriteria } from './pdmsupplychaincriteria';
import { PDMPart } from './pdmpart';
import { SecurityScope } from '../../shared/api/securityscope';
import { SysMLNamespace } from '../../sysml/api/sysmlnamespace';
import { SysMLType } from '../../sysml/api/sysmltype';
import { Workspace } from '../../base/api/workspace';
import { Industry } from '../../base/api/industry';
import { Task } from '../../tasks/api/task';
import { IslandPin } from '../../rflp/api/islandpin';



// Field names for order_by on PDMProduct
type PDMProductFields = "created_at" | "-created_at" | "name" | "-name";

// Field names for order_by on PDMRequirement
type PDMRequirementFields = "created_at" | "-created_at" | "name" | "-name" | "priority" | "-priority" | "status" | "-status";

// Field names for order_by on PDMSupplyChainCriteria
type PDMSupplyChainCriteriaFields = "created_at" | "-created_at" | "name" | "-name" | "priority" | "-priority" | "status" | "-status";


// Include spec for query: PdmProductWithIncludesIncludeSpec
export interface PdmProductWithIncludesIncludeSpec {
  requirements?: {
    _limit?: number;  // max 100
  };
  supply_chain?: {
    _limit?: number;  // max 100
  };
  actions?: {
    _limit?: number;  // max 100
  };
}


// Builder chain for query: pdm-product-by-id

export interface PdmProductByIdBuilder_0 {
  get(id: string): PdmProductByIdBuilder_1;
  filter(conditions: { id: string }): PdmProductByIdBuilder_1;
}

export interface PdmProductByIdBuilder_1 {
  all(): Promise<PDMProduct[]>;
  first(): Promise<PDMProduct | null>;
  get(): Promise<PDMProduct[]>;
  execute(): Promise<PDMProduct[]>;
}

// Builder chain for query: pdm-product-with-requirements

export interface PdmProductWithRequirementsBuilder_0 {
  get(id: string): PdmProductWithRequirementsBuilder_1;
  filter(conditions: { id: string }): PdmProductWithRequirementsBuilder_1;
}

export interface PdmProductWithRequirementsBuilder_1 {
  requirements: PdmProductWithRequirementsBuilder_2;
}

export interface PdmProductWithRequirementsBuilder_2 {
  orderBy(field?: PDMRequirementFields): PdmProductWithRequirementsBuilder_2;
}

export interface PdmProductWithRequirementsBuilder_2 {
  limit(value?: number): PdmProductWithRequirementsBuilder_2;
  all(): Promise<PDMRequirement[]>;
  first(): Promise<PDMRequirement | null>;
  get(): Promise<PDMRequirement[]>;
  execute(): Promise<PDMRequirement[]>;
}

// Builder chain for query: pdm-product-with-supply-chain

export interface PdmProductWithSupplyChainBuilder_0 {
  get(id: string): PdmProductWithSupplyChainBuilder_1;
  filter(conditions: { id: string }): PdmProductWithSupplyChainBuilder_1;
}

export interface PdmProductWithSupplyChainBuilder_1 {
  supply_chain: PdmProductWithSupplyChainBuilder_2;
}

export interface PdmProductWithSupplyChainBuilder_2 {
  orderBy(field?: PDMSupplyChainCriteriaFields): PdmProductWithSupplyChainBuilder_2;
}

export interface PdmProductWithSupplyChainBuilder_2 {
  limit(value?: number): PdmProductWithSupplyChainBuilder_2;
  all(): Promise<PDMSupplyChainCriteria[]>;
  first(): Promise<PDMSupplyChainCriteria | null>;
  get(): Promise<PDMSupplyChainCriteria[]>;
  execute(): Promise<PDMSupplyChainCriteria[]>;
}

// Builder chain for query: pdm-product-with-actions

export interface PdmProductWithActionsBuilder_0 {
  get(id: string): PdmProductWithActionsBuilder_1;
  filter(conditions: { id: string }): PdmProductWithActionsBuilder_1;
}

export interface PdmProductWithActionsBuilder_1 {
  actions: PdmProductWithActionsBuilder_2;
}

export interface PdmProductWithActionsBuilder_2 {
  limit(value?: number): PdmProductWithActionsBuilder_2;
  all(): Promise<PDMAction[]>;
  first(): Promise<PDMAction | null>;
  get(): Promise<PDMAction[]>;
  execute(): Promise<PDMAction[]>;
}

// Builder chain for query: pdm-product-with-includes

export interface PdmProductWithIncludesBuilder_0 {
  get(id: string): PdmProductWithIncludesBuilder_1;
  filter(conditions: { id: string }): PdmProductWithIncludesBuilder_1;
}

export interface PdmProductWithIncludesBuilder_1 {
  load(include: PdmProductWithIncludesIncludeSpec): PdmProductWithIncludesBuilder_1;
  all(): Promise<PDMProduct[]>;
  first(): Promise<PDMProduct | null>;
  get(): Promise<PDMProduct[]>;
  execute(): Promise<PDMProduct[]>;
}

// Builder chain for query: pdm-products-list

export interface PdmProductsListBuilder_0 {
  orderBy(field?: PDMProductFields): PdmProductsListBuilder_0;
}

export interface PdmProductsListBuilder_0 {
  limit(value?: number): PdmProductsListBuilder_0;
  all(): Promise<PDMProduct[]>;
  first(): Promise<PDMProduct | null>;
  get(): Promise<PDMProduct[]>;
  execute(): Promise<PDMProduct[]>;
}


// Union of all query entry points
export type PDMProductQueryBuilder = PdmProductByIdBuilder_0 | PdmProductWithRequirementsBuilder_0 | PdmProductWithSupplyChainBuilder_0 | PdmProductWithActionsBuilder_0 | PdmProductWithIncludesBuilder_0 | PdmProductsListBuilder_0;

// Available query names for .setQuery()
export type PDMProductQueryNames = "pdm-product-by-id" | "pdm-product-with-requirements" | "pdm-product-with-supply-chain" | "pdm-product-with-actions" | "pdm-product-with-includes" | "pdm-products-list";

// Type narrowing for .setQuery()
export type PDMProductBuilderForQuery<Q extends PDMProductQueryNames> =
  Q extends "pdm-product-by-id" ? PdmProductByIdBuilder_0
  : Q extends "pdm-product-with-requirements" ? PdmProductWithRequirementsBuilder_0
  : Q extends "pdm-product-with-supply-chain" ? PdmProductWithSupplyChainBuilder_0
  : Q extends "pdm-product-with-actions" ? PdmProductWithActionsBuilder_0
  : Q extends "pdm-product-with-includes" ? PdmProductWithIncludesBuilder_0
  : Q extends "pdm-products-list" ? PdmProductsListBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type PDMProductInstanceQueryResult<Q extends PDMProductQueryNames> =
  Q extends "pdm-product-by-id" ? PdmProductByIdBuilder_1
  : Q extends "pdm-product-with-requirements" ? PdmProductWithRequirementsBuilder_1
  : Q extends "pdm-product-with-supply-chain" ? PdmProductWithSupplyChainBuilder_1
  : Q extends "pdm-product-with-actions" ? PdmProductWithActionsBuilder_1
  : Q extends "pdm-product-with-includes" ? PdmProductWithIncludesBuilder_1
  : Q extends "pdm-products-list" ? PdmProductsListBuilder_0
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'pdm-product-with-includes',
  'requirements|order_by|limit': 'pdm-product-with-requirements',
  'supply_chain|order_by|limit': 'pdm-product-with-supply-chain',
  'actions|limit': 'pdm-product-with-actions',
  'order_by|limit': 'pdm-products-list',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends PDMProductQueryNames>(queryName: Q): PDMProductBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'actions', {
  get() {
    return new QueryBuilderImpl('PDMAction', [...this.path, 'actions'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(QueryBuilderImpl.prototype, 'requirements', {
  get() {
    return new QueryBuilderImpl('PDMRequirement', [...this.path, 'requirements'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(QueryBuilderImpl.prototype, 'supply_chain', {
  get() {
    return new QueryBuilderImpl('PDMSupplyChainCriteria', [...this.path, 'supply_chain'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface PDMProduct extends Partial<PDMProductReadAPI> {}
export class PDMProduct extends NeoNodeBase<PDMProductReadAPI, PDMProductWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "PDMProduct";
  static readonly readSchema = PDMProductReadAPISchema;
  static readonly writeSchema = PDMProductWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    member_namespace: { target: "SysMLNamespace", cardinality: "one", isParent: false, relClass: "HasMembers", direction: "in" },
    general: { target: "SysMLType", cardinality: "many", isParent: false, relClass: "Specializes", direction: "out" },
    specific: { target: "SysMLType", cardinality: "many", isParent: false, relClass: "Specializes", direction: "in" },
    workspace: { target: "Workspace", cardinality: "one", isParent: false, relClass: "HasProduct", direction: "in" },
    industry: { target: "Industry", cardinality: "one", isParent: false, relClass: "BelongsToIndustry", direction: "out" },
    requirements: { target: "PDMRequirement", cardinality: "many", isParent: false, relClass: "HasRequirements", direction: "out" },
    actions: { target: "PDMAction", cardinality: "many", isParent: false, relClass: "HasActions", direction: "out" },
    root_part: { target: "PDMPart", cardinality: "one", isParent: false, relClass: "HasRootPart", direction: "out" },
    supply_chain: { target: "PDMSupplyChainCriteria", cardinality: "many", isParent: false, relClass: "HasSupplyChainCriteria", direction: "out" },
    current_tasks: { target: "Task", cardinality: "many", isParent: false, relClass: "CurrentTaskAttachedTo", direction: "in" },
    island_pins: { target: "IslandPin", cardinality: "many", isParent: false, relClass: "IslandHoldsPin", direction: "out" },
  };

  protected get modelName(): string {
    return 'PDMProduct';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return PDMProduct.label;
  }


  constructor(data: Partial<PDMProductWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: PDMProductReadAPI, loadContext?: Record<string, any>): PDMProduct {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { industry, requirements, actions, root_part, supply_chain, security_scope, member_namespace, general, specific, workspace, current_tasks, island_pins, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = PDMProductReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, industry: industry, requirements: requirements, actions: actions, root_part: root_part, supply_chain: supply_chain, security_scope: security_scope, member_namespace: member_namespace, general: general, specific: specific, workspace: workspace, current_tasks: current_tasks, island_pins: island_pins };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return PDMProduct.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'industry', 'Industry', ModelRegistry);
    loadManyRelationship(processed, 'requirements', 'PDMRequirement', ModelRegistry);
    loadManyRelationship(processed, 'actions', 'PDMAction', ModelRegistry);
    loadOneRelationship(processed, 'root_part', 'PDMPart', ModelRegistry);
    loadManyRelationship(processed, 'supply_chain', 'PDMSupplyChainCriteria', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'member_namespace', 'SysMLNamespace', ModelRegistry);
    loadManyRelationship(processed, 'general', 'SysMLType', ModelRegistry);
    loadManyRelationship(processed, 'specific', 'SysMLType', ModelRegistry);
    loadOneRelationship(processed, 'workspace', 'Workspace', ModelRegistry);
    loadManyRelationship(processed, 'current_tasks', 'Task', ModelRegistry);
    loadManyRelationship(processed, 'island_pins', 'IslandPin', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new PDMProduct(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): PDMProductQueryBuilder {
    return new QueryBuilderImpl('PDMProduct').filter(conditions) as any;
  }

  static all(): PDMProductQueryBuilder {
    return new QueryBuilderImpl('PDMProduct') as any;
  }

  static async first(): Promise<PDMProduct | null> {
    const results = await new QueryBuilderImpl('PDMProduct').execute();
    return results[0] || null;
  }


  static setQuery<Q extends PDMProductQueryNames>(queryName: Q): PDMProductBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('PDMProduct');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends PDMProductQueryNames>(queryName: Q): PDMProductInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = PDMProduct.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const pdmproduct = await PDMProduct.get(id).first();
   * await pdmproduct.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await pdmproduct.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'requirements' - Python ORM style (cached)
  get requirements(): RelationshipManager<this, PDMRequirement> {
    return this.getOrCreateRelationshipManager('requirements', () => {
      return new RelationshipManager(this, 'requirements', 'many', HasRequirements as typeof Relationship);
    });
  }

  // Relationship manager for 'actions' - Python ORM style (cached)
  get actions(): RelationshipManager<this, PDMAction> {
    return this.getOrCreateRelationshipManager('actions', () => {
      return new RelationshipManager(this, 'actions', 'many', HasActions as typeof Relationship);
    });
  }

  // Relationship manager for 'root_part' - Python ORM style (cached)
  get root_part(): RelationshipManager<this, PDMPart> {
    return this.getOrCreateRelationshipManager('root_part', () => {
      return new RelationshipManager(this, 'root_part', 'one', HasRootPart as typeof Relationship);
    });
  }

  // Relationship manager for 'supply_chain' - Python ORM style (cached)
  get supply_chain(): RelationshipManager<this, PDMSupplyChainCriteria> {
    return this.getOrCreateRelationshipManager('supply_chain', () => {
      return new RelationshipManager(this, 'supply_chain', 'many', HasSupplyChainCriteria as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'member_namespace' - Python ORM style (cached)
  get member_namespace(): RelationshipManager<this, SysMLNamespace> {
    return this.getOrCreateRelationshipManager('member_namespace', () => {
      return new RelationshipManager(this, 'member_namespace', 'one', HasMembers as typeof Relationship);
    });
  }

  // Relationship manager for 'general' - Python ORM style (cached)
  get general(): RelationshipManager<this, SysMLType> {
    return this.getOrCreateRelationshipManager('general', () => {
      return new RelationshipManager(this, 'general', 'many', Specializes as typeof Relationship);
    });
  }

  // Relationship manager for 'specific' - Python ORM style (cached)
  get specific(): RelationshipManager<this, SysMLType> {
    return this.getOrCreateRelationshipManager('specific', () => {
      return new RelationshipManager(this, 'specific', 'many', Specializes as typeof Relationship);
    });
  }

  // Relationship manager for 'workspace' - Python ORM style (cached)
  get workspace(): RelationshipManager<this, Workspace> {
    return this.getOrCreateRelationshipManager('workspace', () => {
      return new RelationshipManager(this, 'workspace', 'one', HasProduct as typeof Relationship);
    });
  }

  // Relationship manager for 'industry' - Python ORM style (cached)
  get industry(): RelationshipManager<this, Industry> {
    return this.getOrCreateRelationshipManager('industry', () => {
      return new RelationshipManager(this, 'industry', 'one', BelongsToIndustry as typeof Relationship);
    });
  }

  // Relationship manager for 'current_tasks' - Python ORM style (cached)
  get current_tasks(): RelationshipManager<this, Task> {
    return this.getOrCreateRelationshipManager('current_tasks', () => {
      return new RelationshipManager(this, 'current_tasks', 'many', CurrentTaskAttachedTo as typeof Relationship);
    });
  }

  // Relationship manager for 'island_pins' - Python ORM style (cached)
  get island_pins(): RelationshipManager<this, IslandPin> {
    return this.getOrCreateRelationshipManager('island_pins', () => {
      return new RelationshipManager(this, 'island_pins', 'many', IslandHoldsPin as typeof Relationship);
    });
  }

}
